module.exports = __webpack_public_path__ + "media/images/mobile/city_img/b2-5bcff454475518d8beadb3208fd2c3d0.jpg";